import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { User } from 'src/app/auth/user.model';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AddEditCompetitorComponent } from './add-edit-competitor/add-edit-competitor.component';

@Component({
    selector: 'app-product-competitors',
    templateUrl: './product-competitors.component.html',
    styleUrls: ['./product-competitors.component.scss'],
    standalone: false
})
export class ProductCompetitorsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  competitorsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  searchValue = "";
  productId: any;
  selected = 'manufacturer';
  usedOnMobile = null;
  user: User;
  productName: any;

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private router: Router) {
          this.showSearch = false;
          this.user = this.authService.getUserData();
          this.userID = this.user.id;
          this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
          this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
          this.route.queryParams.subscribe((params: Params) => {
            if (!this.isEmpty(params)) {
              this.pageNumber = params.pageNumber ? params.pageNumber : 1;
              this.pageSize = params.pageSize ? params.pageSize : 10;
              this.searchValue =  params.searchValue ? params.searchValue : "";
              this.usedOnMobile = params.usedOnMobile;
              this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
              if (params.usedOnMobile === undefined) {
                if (this.user.type === this.utils.userTypes.Distributor) {
                  this.usedOnMobile = true;
                } else {
                  this.usedOnMobile = null;
                }
                this.selected = 'usedOnMobile';
              }
              } else {
                if (this.user.type === this.utils.userTypes.Distributor) {
                  this.selected = 'usedOnMobile';
                  this.usedOnMobile = true;
                }
              }
            this.getCompetitors();
            });
          }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
        secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/general',
      });
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  goToPositioning(competitorId: any, competitorName: any) {
    this.router.navigate(['/products/product/' + this.productId + '/' + this.productName + '/competitor/' + competitorId + '/' + encodeURIComponent(competitorName) +  '/positioning']);
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('product/competitor/UpdateUsedOnMobile', {
      CompetitorId : id,
      ProductId : parseInt(this.productId.toString(), 10),
      usedOnMobile : true
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getCompetitors();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('product/competitor/UpdateUsedOnMobile', {
      CompetitorId : id,
      ProductId : parseInt(this.productId.toString(), 10),
      usedOnMobile : false
    }).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getCompetitors();
      }
    });
  }

  openAddCompetitor() {
    const dialogRef = this.dialog.open(AddEditCompetitorComponent, {disableClose: true, width: '500px', data: {type: 'Add', productId: this.productId}});
    dialogRef.afterClosed().subscribe((newCompetitor) => {
      if (newCompetitor) {
        if (this.user.type === this.utils.userTypes.Manufacturer) {
          this.competitorsList.unshift(newCompetitor);
          this.totalSize = this.totalSize + 1;
          if (this.competitorsList.length <= this.pageSize) {
          } else {
            this.competitorsList.splice(this.competitorsList.length - 1, 1);
          }
        } else {
          if (this.selected === 'usedOnMobile') {
            this.competitorsList.unshift(newCompetitor);
            this.totalSize = this.totalSize + 1;
            if (this.competitorsList.length <= this.pageSize) {
            } else {
              this.competitorsList.splice(this.competitorsList.length - 1, 1);
            }
          }
        }
        this.getCompetitors();
      }
    });
  }

  editCompetitor(competitor: any) {
    const dialogRef = this.dialog.open(AddEditCompetitorComponent, {
      disableClose: true,
      width: '500px',
      data: {
        type: 'Edit',
        productId: this.productId,
        competitor
      }
    });
    dialogRef.afterClosed().subscribe((editedCompetitor) => {
      if (editedCompetitor) {
        this.getCompetitors();
      }
    });
  }

  deleteCompetitor(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'competitor',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('product/competitor/DeleteProductCompetitor/' + this.productId +'/' + id).then((data) => {
            if (data.statusCode === 200) {
              this.competitorsList.forEach( (competitors, index) => {
                if (competitors.id === id) {
                  this.competitorsList.splice(index, 1);
                  if (this.competitorsList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
                      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
                    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
                    '/competitors'], { queryParams: this.queryParams });
                  } else {
                    this.getCompetitors();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Competitor deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }

  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitors'], { queryParams: this.queryParams });
    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitors'], { queryParams: this.queryParams });
    }
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/competitors'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch && this.competitorsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/competitors'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/competitors'], { queryParams: this.queryParams });
  }

  getCompetitors() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('product/competitor/RetrieveProductCompetitors/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&AddedBy=2').then((data: any) => {
        if (data.statusCode === 200) {
          this.competitorsList = [];
          const competitorsData = data.data.records;
          this.totalSize = data.data.count;
          competitorsData.forEach((competitorData: any) => {
            // const competitorInstance = new Competitor(competitorData);
            this.competitorsList.push(competitorData);
          });
          if (competitorsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/competitors'], { queryParams: this.queryParams });
          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('product/competitor/RetrieveProductCompetitors/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.competitorsList = [];
          const competitorsData = data.data.records;
          this.totalSize = data.data.count;
          competitorsData.forEach((competitorData: any) => {
            // const competitorInstance = new Competitor(competitorData);
            this.competitorsList.push(competitorData);
          });
          if (competitorsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/competitors'], { queryParams: this.queryParams });
          }
        }
      });
    }
  }

}
